export default __webpack_public_path__ + "static/media/team9.3eb2443c.png";